import { getMessages } from '../../../../../../store/constants';

export const DATES_TITLE = getMessages().getText('board_settings.dates.title');
export const DATES_AUTO_TITLE = getMessages().getText('board_settings.dates.auto_start_date.title');
export const DATES_AUTO_TEXT = getMessages().getText('board_settings.dates.auto_start_date.text');
export const DATES_TEXT = getMessages().getText('board_settings.dates.text');
export const DATES_START_LABEL = getMessages().getText('board_settings.dates.label.start');
export const DATES_DUE_LABEL = getMessages().getText('board_settings.dates.label.due');
